module.exports = __webpack_public_path__ + "static/media/Wed3.ca2209a5.jpg";